<template>
    <module-card :nextDisabled="nextDisabled">
        <p class="text-h6">How do you think Philip is feeling at this moment with Rodney?</p>
        <p>Slide the scale below to indicate how much you think Philip is feeling the following emotion</p>
        <p class="text-h4 text-center selected-text">{{ currentEmotion }}</p>
        <v-slider @change="sliderChange" v-model="sliderChoice" :max="9" step="1" track-color="primary" thumb-color="red" ticks="always" tick-size="5"></v-slider>
        <div class="arrow-container">
            <div class="arrow-label">The least</div>
            <div class="arrow-wrapper">
                <div class="arrow middle"></div>
            </div>
            <div class="arrow-label">The most</div>
        </div>
    </module-card>
</template>

<script>
    export default {
        data() {
            return {
                emotions: ['Horny', 'Guilty', 'Confident', 'In Love', 'Loved']
            };
        },
        props: {
            emotion: {
                type: Number,
                required: true
            }
        },
        computed: {
            currentEmotion() {
                return this.emotions[this.emotion - 1];
            },
            // this is a bit ugly; the slider model is "sliderChoice", but the actual selected choice is "choice"
            // this allows us to put the thumb in the middle of the slider when no choice is actually selected
            choice() {
                let choice = this.$store.get(`peepInLoveEmotions@${this.emotion}.choice`);

                return choice;
            },
            sliderChoice: {
                get() {
                    // if the user has selected value for this statement already, we want to display that;
                    // but if not, we want no choice to be selected, but still but the slider thumb in the
                    // middle of the slider.
                    if (this.choice === null) {
                        return 5;
                    }
                    return this.choice;
                },
                // have to define a computed setter but don't actually want it to do anything; bypass lint
                // eslint-disable-next-line no-unused-vars
                set(v) {}
            }
        },
        methods: {
            nextDisabled() {
                return this.choice === null;
            },
            sliderChange(newValue) {
                this.$store.set(`peepInLoveEmotions@${this.emotion}.choice`, newValue);
            }
        }
    };
</script>

<style scoped>
    ::v-deep .v-slider__tick {
        background-color: var(--v-primary-base);
    }

    .selected-text {
        white-space: pre-wrap;
    }

    .arrow-label {
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        width: 85px;
    }

    .arrow-wrapper {
        display: flex;
        width: 100%;
        align-items: center;
    }

    .arrow-container {
        display: flex;
        padding: 0px;
    }
    .middle {
        flex-grow: 1;
    }

    .arrow {
        position: relative;
        margin: 12px 20px;
        height: 0;
        border-bottom: 1px dotted var(--v-primary-base);
    }

    .arrow::after {
        content: '';
        width: 0;
        height: 0;
        border-top: 8px solid transparent;
        border-bottom: 8px solid transparent;
        border-left: 12px solid var(--v-primary-base);
        position: absolute;
        right: -10px;
        top: -8px;
    }

    .arrow::before {
        content: '';
        width: 0;
        height: 0;
        border-top: 8px solid transparent;
        border-bottom: 8px solid transparent;
        border-right: 12px solid var(--v-primary-base);
        position: absolute;
        left: -10px;
        top: -8px;
    }
</style>
